import { Pipe, PipeTransform } from '@angular/core';
import { COMMON_CONSTANTS } from 'src/app/common/core/common.constants';


@Pipe({
  name: 'udfFormat',
})
export class UdfFormatPipe implements PipeTransform {

  transform(value: string, maxlength: number): any {
    if (value.length > maxlength) {
      return value.substring(COMMON_CONSTANTS.DIGITS.ZERO, COMMON_CONSTANTS.DIGITS.TWELVE) + COMMON_CONSTANTS.THREE_DOTS;
    } else {
      return value;
    }
  }

}
